import { Immutable } from '@zervant/reactcomponents'

import { FreeTextInterface } from '../Interfaces/FreeTextInterface'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = []

type StateType = FreeTextInterface[]
type PayloadType = FreeTextInterface[] | FreeTextInterface | number

function _getFreetexts(state: StateType, payload: FreeTextInterface[]): StateType {
  return Immutable.copy(payload)
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('GET_FREETEXTS', _getFreetexts)
  .build()

export default reducer
